import { api } from './client'
import { Announcement } from '../types'

export async function getLatestAnnouncement(): Promise<Announcement | null> {
  const res = await api.get('/api/v1/broadcast/latest')
  return res.data
}

export async function previewSegment(params: {
  segment: string
  segment_params?: Record<string, number>
}): Promise<{ count: number }> {
  const res = await api.post('/api/v1/broadcast/preview', params)
  return res.data
}

export async function sendBroadcast(data: {
  title: string
  body: string
  image_path?: string
  segment: string
  segment_params?: Record<string, number>
  send_bot: boolean
  send_miniapp: boolean
}): Promise<Announcement> {
  const res = await api.post('/api/v1/broadcast/send', data)
  return res.data
}
